import React from "react";
import "./App.css";
import Pre from './images/pre.png';
import Next from './images/next.png';

export const NextArrow = ({ onClick }) => (
  <div className="custom-arrow next" onClick={onClick}>
   <img src={Next}/>
  </div>
);

export const PrevArrow = ({ onClick }) => (
  <div className="custom-arrow prev" onClick={onClick}>
   <img src={Pre}/>
  </div>
);